import {
  Required,
  Schema,
  TextField,
  RemoteDataSource,
  DynamicColumn
} from "lego-gui-lib/lib";
import { createContext } from "react";
import { mainStore, api } from "../../core/mainStore";
import { CustomerFK } from "../customer/schema";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";
import {
  customerChanged,
  customerInit,
  onVisibilityChange,
  onVisibilityInit,
  VisibilityEnum,
  VisibilityType,
  withVisibility
} from "../../common/common";
import get from "lodash/get";
import { ContextAwareListDataSource } from "../../common/ContextAwareListDataSource";
import { AccessContext, ForeignKeyField } from "lego-gui-lib";

const auth = mainStore.auth;

export const AreaSplittingSchema = new Schema<DynamicColumn>({
  primaryKey: ["id"],
  defaultSort: { sort: "visibility", order: "desc" },
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "visibility",
      title: t("common:visibility"),
      type: VisibilityEnum(),
      readonly: () => !auth.isAdmin(),
      onChange: onVisibilityChange,
      onInit: onVisibilityInit
    },
    {
      name: "customerRef",
      type: CustomerFK,
      title: t("hns:customer:domain"),
      if: () => auth.isAdmin(),
      onChange: customerChanged,
      onInit: customerInit
    }
  ]
});

export const CreateAreaSplittingSchema = AreaSplittingSchema.extend({
  visibility: {
    type: VisibilityEnum(),
    onChange: onVisibilityChange,
    onInit: onVisibilityInit
  },
  customerRef: {
    if: (ctx: AccessContext) =>
      auth.isAdmin() && get(ctx, "data.visibility") === VisibilityType.PRIVATE
  }
});

export const EditAreaSplittingSchema = CreateAreaSplittingSchema.extend({
  visibility: {
    readonly: true
  },
  customerRef: {
    readonly: true
  }
});

mainStore.areaSplitting = RemoteDataSource.create({
  api: api,
  name: "areaSplitting",
  schema: AreaSplittingSchema,
  url: "/areaSplittings",
  commons: mainStore.commons
});

export const areaSplittingContext = createContext(mainStore.areaSplitting);

mainStore.areaSplittingFk = ContextAwareListDataSource.clone(
  mainStore.areaSplitting,
  {
    observableFieldRef: "customerRef",
    observableDataSource: "customer"
  }
);

export const customerAreaSplittingContext = createContext(
  mainStore.areaSplittingFk
);

export const AreaSplittingFK = ForeignKeyField(
  {
    dataSource: mainStore.areaSplittingFk,
    labelField: withVisibility(),
    searchField: "name",
    valueField: "id"
  },
  Required
);

export const AreaSplittingFKNotRequired = ForeignKeyField({
  dataSource: mainStore.areaSplittingFk,
  labelField: withVisibility(),
  searchField: "name",
  valueField: "id"
});
